<section class="header-container">
  <mat-icon class="logo-mat-icon" svgIcon="vspVisionLogo" [matTooltipPosition]="'left'" matTooltip="VSP Logo"></mat-icon>
  <a id="logoutLink" [hidden]="!isLogoutEnabled()" [routerLink]="['/']" (click)="logout()" class="logout-link">
    <div id="logoutContainer" class="logout-container">
        <mat-icon class="logout-icon" svgIcon="vsp-icons:logout"></mat-icon>
        <div id="logoutLabel" class="logout-label">logout</div>
    </div>
  </a>
</section>
